import csrImg from "../../Images/csr.jpeg";
export function CSR() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title">CSR</h2>
              <p>
                As our company grows, we from this year onward consider it our
                responsibility to give back to the society. We consider CSR to
                be a core and inseparable component of our overall product
                offering. We do not aim to solely provide a financial
                contribution but to open up the minds and the power of our
                people to achieve a positive impact. We look forward to start
                this journey by encouraging our employees to consider how the
                company might be able to do better in the world.
              </p>
              <p>
                We have allocated a portion of our resources to CSR initiatives
                because we recognize our responsibility to give back to the
                community. Through our CSR funds, we support various projects
                and causes that align with our values. From promoting education
                and healthcare to environmental sustainability and community
                development, we are committed to contributing to the well-being
                of the communities in which we operate. By investing in CSR, we
                aim to create a better and brighter future for all, extending
                our commitment beyond pharmaceutical innovation to the
                betterment of people's lives.
              </p>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={csrImg} alt="CSR" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
